module.exports = __webpack_public_path__ + "static/img/2.03e4a3b6.png";